import axios from "axios";
import config from "../../config";
import './UserAnswers.css';
import React, {useEffect, useState} from "react";
import {useTranslation} from "react-i18next";
import scrollToTop from "../../scripts/scroll-to-top";

interface UserAnswersProps {
    setNewCurrentStep(step: number): void
    answers: any[]
    isMobileScreen: boolean

}
function UserAnswers(props: UserAnswersProps) {
    const { t, i18n } = useTranslation();
    const [loaderIsActive, setLoaderIsActive] = useState(false);

    const nextStep = () => {
        props.setNewCurrentStep(4)
    }

    const goBackToTheQuiz = () => {
        props.setNewCurrentStep(2)
    }

    const submitForm = async () => {
        try {
            const userAnswersObj = prepareBodyRequestObject(props.answers);

            setLoaderIsActive(true);
            scrollToTop();

            await axios.post(
                config.API_URL_FOR_LOCAL_DEVELOPMENT + '/api/v1/quiz-climacteric/questions/store',
                {
                    ...userAnswersObj,
                    language: config.LANGUAGE || 'en',
                    landingUserId: window.localStorage.getItem('landingUserId'),
                }
            );

            nextStep()
        } catch (error) {
            console.error('Error while sending data:', error);
        } finally {
            setLoaderIsActive(false);
        }
    }

    const prepareBodyRequestObject = (inputArray: any[]) => {
        const outputObject: any = {};

        inputArray.forEach(item => {
            outputObject[item.key] = item.value;
        });

        for (let i = 1; i <= inputArray.length; i++) {
            const key = `q${i}`;
            if (!outputObject.hasOwnProperty(key)) {
                outputObject[key] = "";
            }
        }

        return outputObject;
    }

    useEffect(() => {
        scrollToTop();
    }, [])

    return (
        <div className='UserAnswers'>

            <h1 className="title-1 mb-3 text-start text-md-center">{t('Your Answers')}</h1>

            {
                !props.isMobileScreen &&
                <div className="d-flex">
                    <div className="table mr-3">
                        <div className="table-head table-row d-flex">
                            <div className="table-col"></div>
                            <div className="table-col">{t('Questions')}</div>
                            <div className="table-col">{t('Answers')}</div>
                        </div>
                        {
                            props.answers && props.answers
                                .slice(0, 10)
                                .map((answer, index: number) => (
                                    <div
                                        className='table-row d-flex'
                                        key={answer.key}
                                    >
                                        <div className='table-col'>{index + 1}</div>
                                        <div className='table-col'>{answer.label}</div>
                                        <div className='table-col'>{answer.valueContent}</div>
                                    </div>
                                ))
                        }
                    </div>

                    <div className="table">
                        <div className="table-head table-row d-flex">
                            <div className="table-col"></div>
                            <div className="table-col">Questions</div>
                            <div className="table-col">Answers</div>
                        </div>

                        {
                            props.answers && props.answers
                                .slice(10, 21)
                                .map((answer, index: number) => (
                                    <div
                                        className='table-row d-flex'
                                        key={answer.key}
                                    >
                                        <div className='table-col'>{index + 11}</div>
                                        <div className='table-col'>{answer.label}</div>
                                        <div className='table-col'>{answer.valueContent}</div>
                                    </div>
                                ))
                        }
                    </div>
                </div>
            }

            {
                props.isMobileScreen &&
                <div>
                    <div className="table mr-3">
                        <div className="table-head table-row d-flex">
                            <div className="table-col"></div>
                            <div className="table-col">Questions</div>
                            <div className="table-col">Answers</div>
                        </div>
                        {
                            props.answers && props.answers
                                .map((answer, index: number) => (
                                    <div
                                        className='table-row d-flex'
                                        key={answer.key}
                                    >
                                        <div className='table-col'>{index + 1}</div>
                                        <div className='table-col'>{answer.label}</div>
                                        <div className='table-col'>{answer.valueContent}</div>
                                    </div>
                                ))
                        }
                    </div>
                </div>
            }

            <footer className='d-flex justify-content-center align-items-center mt-5 position-relative'>
                <button
                    className='button-1 mr-6'
                    onClick={() => goBackToTheQuiz()}
                >
                    {t('Back Button')}
                </button>

                <button
                    className='button-1'
                    onClick={() => submitForm()}
                >
                    {t('Continue Button')}
                </button>

                {loaderIsActive && <div className='submitting-overlay submitting-overlay--small'></div>}
            </footer>
        </div>
    );
}

export default UserAnswers;
